import { store } from "../../../../../redux/store";
import { t, Translation } from "../../../../core/translate";
import {
  actions as feedbackActions,
  selectors as feedbackSelectors
} from "../../../../../redux/feedback";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import MenuItem from "../../../../components/list-item";
import { navigateTo, navigateSafelyTo } from "./shared";
import { OffScreenSpan } from "../../promotions-lane/promotion-element";
import React from "react";

export const support = () => {
  const state = store.getState();
  const showSupport = brandSelectors.getBrandValue(state, "Support.visible");
  const linkToSupport = brandSelectors.getBrandValue(state, "Support.url");
  const supportLabel = brandSelectors.getBrandValue(
    state,
    "Support.label",
    t("global-bar.support", "Support")
  );
  return MenuItem({
    condition: showSupport,
    onClick: event => navigateSafelyTo(event, linkToSupport, "support"),
    text: supportLabel,
    href: linkToSupport,
    target: "_blank"
  });
};

export const privacy = () => {
  const state = store.getState();
  const showPrivacy = brandSelectors.getBrandValue(state, "Privacy.enabled");
  const linkToPrivacy = brandSelectors.getBrandValue(state, "Privacy.url");
  const defaultPrivacyLink =
    "https://support.vitalsource.com/hc/en-us/articles/201646123";
  const link =
    linkToPrivacy || t("locations.zendesk-privacy", defaultPrivacyLink);

  return MenuItem({
    condition: showPrivacy,
    onClick: event => navigateTo(event, link, "privacy"),

    text: t("main-menu.privacy", "Privacy"),
    href: link,
    target: "_blank"
  });
};

export const terms = () => {
  const state = store.getState();
  const showTerms = brandSelectors.getBrandValue(state, "Terms.enabled");
  const linkToTerms = brandSelectors.getBrandValue(state, "Terms.url");
  const defaultTermsLink =
    "https://support.vitalsource.com/hc/en-us/articles/204612518";
  const link = linkToTerms || t("locations.zendesk-tou", defaultTermsLink);

  return MenuItem({
    condition: showTerms,
    onClick: event => navigateSafelyTo(event, link, "terms"),
    text: t("main-menu.terms", "Terms"),
    href: link,
    target: "_blank"
  });
};

export const about = () => {
  const state = store.getState();
  const showAbout = brandSelectors.getBrandValue(state, "About.enabled");
  const linkToAbout = brandSelectors.getBrandValue(state, "About.url");
  const aboutLabel = brandSelectors.getBrandValue(
    state,
    "About.label",
    t("global-bar.about", "About")
  );

  return MenuItem({
    condition: showAbout,
    onClick: event => navigateSafelyTo(event, linkToAbout, "about"),
    text: aboutLabel,
    href: linkToAbout,
    target: "_blank"
  });
};

export const feedback = () => {
  const state = store.getState();
  const showFeedback = brandSelectors.getBrandValue(state, "Feedback.enabled");
  const isExternal = feedbackSelectors.isFeedbackExternal(state);

  const onClick = () => {
    store.dispatch(feedbackActions.openFeedback());
  };

  let text = t("global-bar.feedback", "Give Feedback");
  if (isExternal) {
    text = (
      <span>
        {text}
        <OffScreenSpan>
          <Translation id="base.new-window">New Window</Translation>
        </OffScreenSpan>
      </span>
    );
  }

  return MenuItem({
    condition: showFeedback,
    onClick,
    text
  });
};

export const noticeCollection = () => {
  const state = store.getState();
  const showNoticeCollection = brandSelectors.getBrandValue(
    state,
    "Menu.notice_collection"
  );
  const noticeCollectionLink =
    "https://support.vitalsource.com/hc/en-us/articles/360050635654-California-Notice-of-Information-Collection";
  const link = t("zendesk-notice-collection", noticeCollectionLink);

  return MenuItem({
    condition: showNoticeCollection,
    onClick: event => navigateSafelyTo(event, link, "notice-collection"),
    text: t("main-menu.notice-collection", "CA Notice of Collection"),
    href: link,
    target: "_blank"
  });
};
